import type { SwitchTeamModeRequest, TeamInfoResponse } from '@shared/types';
import { get, post } from './request';

export async function getTeamInfo(): Promise<TeamInfoResponse> {
  return get<TeamInfoResponse>('/team/info');
}

export async function switchTeamMode(useTeamMode: SwitchTeamModeRequest['use_team_mode']): Promise<TeamInfoResponse> {
  return post<TeamInfoResponse>('/team/switchMode', { use_team_mode: useTeamMode });
}
